module.exports = __webpack_public_path__ + "app-static/img/19.dc382896.png";